<template>
  <div class="page-container">
   <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <span class="page-title">合约历史管理</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>止盈止损历史</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content" shadow="never">
      <div class="page-actions">
     
      </div>
      <user-list @refresh="refreshList"></user-list>
    </el-card>

  </div>
</template>

<script>
import "./store";
import UserList from "./components/list";
import { mapState, mapActions, mapMutations } from "vuex";
import { QUERY_TYPE, PAGINATION } from "./constants";

export default {
  name: "OrderLimt",
  components: {
    UserList,
  },
  data() {
    return {
      dialogVisible: false,
      queryValue: "",
      userStatus: "",
      userType: "",
      mark: null,
      accountInfo: {
        userId: null,
        type: 0,
        allowTrade: true,
        allowTransfer: true,
      },
      userInfo: {
        state: 1,
        userGroupId:1,
      },
      rules: {
        userId: [
          {
            required: true,
            message: "请输入用户的userId",
            trigger: "blur",
          },
        ],
        // type: [{
        //   required: true,
        //   message: '请选择账户类型用户类型',
        //   trigger: 'change'
        // }],
        // state: [{
        //   required: true,
        //   message: '请选择用户状态',
        //   trigger: 'change'
        // }],
      },
      typeOptions: [
        {
          label: "普通账户",
          value: 0,
        },
        {
          label: "量化账户",
          value: 1,
        },
        {
          label: "风险保证金账户",
          value: 2,
        },
      ],
      stateOptions: [
        {
          label: "0",
          value: 0,
        },
        {
          label: "1",
          value: 1,
        },
      ],
      userGroupIdOptions:[
        {
          label: "1",
          value: 1,
        },
        {
          label: "2",
          value: 2,
        },
        {
          label: "3",
          value: 3,
        },
      ],
      status: [
        { value: 0, label: "激活" },
        { value: "-1", label: "冻结" },
      ],
      Shareholder: [
        { value: "1", label: "无效用户" },
        { value: "2", label: "普通用户" },
        { value: "3", label: "初级股东" },
        { value: "4", label: "中级股东" },
        { value: "5", label: "高级股东" },
      ],
      ifMark: [
        { value: true, label: "异常账户" },
        { value: false, label: "非异常账户" },
      ],
    };
  },
  computed: {
    ...mapState("profitLoss", ["queryType", "queryTypeList", "pagination"]),
  },
  methods: {
    ...mapActions("profitLoss", ["list",'addUser']),
    ...mapMutations("profitLoss", ["setQueryType"]),
    refreshList(data = {}) {
      this.list({
        queryType: this.queryType,
        queryValue: this.queryValue,
        userStatus: this.userStatus,
        userType: this.userType,
        ...this.pagination,
        ...data,
      });
    },
    handleSearch() {
      this.list({
        queryType: this.queryType,
        queryValue: this.queryValue,
        userType: this.userType,
        userStatus: this.userStatus,
        mark: this.mark,
        ...PAGINATION,
      });
    },
     handleSave() {},
  closeDialog() {
    this.dialogVisible = false;
  },
  onOpen() {},
  onClose() {
    this.$refs["elForm"].resetFields();
    this.dialogVisible=false
  },
  close() {
    // this.$emit("update:visible", false);
    this.$refs["elForm"].resetFields();
    this.dialogVisible=false
  },
  handelConfirm(elForm) {
    this.$refs[elForm].validate((valid) => {
      if (!valid){
        return;
      } 
      const userId=this.accountInfo.userId
      const userInfoDto={'accountInfo':{...this.accountInfo},'userInfo':{...this.userInfo}}
      this.addUser({'userId':Number(userId),'userInfoDto':userInfoDto}).then(res=>{
        if(res.code==0){
          this.$message.success('添加成功')
          this.dialogVisible=false,
          this.$refs["elForm"].resetFields();
          this.refreshList()
        }
       
      })
      // this.close();
    
    });
  },
  },
  created() {
    this.list({
      queryType: QUERY_TYPE[0].value,
      queryValue: this.queryValue,
      userStatus: this.userStatus,
      userType: this.userType,
      ...PAGINATION,
    });
  },
 
};
</script>

<style lang="less" scoped></style>
